document.addEventListener("DOMContentLoaded", function () {
  const swiperContainers = document.querySelectorAll(".cards-carousel__swiper");
  swiperContainers.forEach(function (container) {
    const swiper = new Swiper(container, {
      slidesPerView: "auto",
      spaceBetween: 12,
      speed: 500,
      navigation: {
        nextEl: container.querySelector(".cards-carousel__next"),
        prevEl: container.querySelector(".cards-carousel__prev")
      },
      pagination: {
        el: container.querySelector(".cards-carousel__pagination")
      },
      breakpoints: {
        640: {
          spaceBetween: 30
        }
      }
    });
  });

  // Logo Grid – Swiper only on mobile (< 768px)
  const logoGridContainers = document.querySelectorAll(".logo-grid__swiper");
  logoGridContainers.forEach(function (container) {
    let logoGridSwiper = null;
    const mobileQuery = window.matchMedia("(max-width: 767px)");
    function handleLogoGridSwiper(e) {
      if (e.matches && !logoGridSwiper) {
        logoGridSwiper = new Swiper(container, {
          slidesPerView: "auto",
          spaceBetween: 32,
          speed: 500,
          loop: true,
          centeredSlides: true,
          pagination: {
            el: container.querySelector(".logo-grid__pagination")
          },
          navigation: {
            nextEl: container.querySelector(".logo-grid__next"),
            prevEl: container.querySelector(".logo-grid__prev")
          }
        });
      } else if (!e.matches && logoGridSwiper) {
        logoGridSwiper.destroy(true, true);
        logoGridSwiper = null;
      }
    }
    handleLogoGridSwiper(mobileQuery);
    mobileQuery.addEventListener("change", handleLogoGridSwiper);
  });
  const testimonialsCarousels = document.querySelectorAll(".testimonials-carousel__content");
  testimonialsCarousels.forEach(function (container) {
    const swiper = new Swiper(container.querySelector(".swiper"), {
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: container.querySelector(".testimonials-carousel__next"),
        prevEl: container.querySelector(".testimonials-carousel__prev")
      }
    });
  });
  const textCarouselImages = document.querySelectorAll(".text-carousel__images");
  textCarouselImages.forEach(function (container) {
    const swiper = new Swiper(container.querySelector(".swiper"), {
      effect: "fade",
      loop: true,
      pagination: {
        el: container.querySelector(".text-carousel__pagination")
      },
      navigation: {
        nextEl: container.querySelector(".text-carousel__next"),
        prevEl: container.querySelector(".text-carousel__prev")
      }
    });
  });
  const accordions = document.querySelectorAll(".map-accordion .accordion");
  accordions.forEach(accordion => {
    const button = accordion.querySelector(".accordion__button");
    const content = accordion.querySelector(".accordion__content");
    button.addEventListener("click", () => {
      const isOpen = content.style.maxHeight;
      accordions.forEach(acc => {
        acc.querySelector(".accordion__content").style.maxHeight = null;
        acc.querySelector(".accordion__button").classList.remove("active");
      });
      if (!isOpen) {
        content.style.maxHeight = content.scrollHeight + 16 + "px";
        button.classList.add("active");
      }
    });
  });
  const galleryBlock = document.getElementsByClassName("gallery-images");
  if (galleryBlock.length) {
    Array.from(galleryBlock).forEach(function (block) {
      lightGallery(block, {
        selector: "a",
        plugins: []
        // Configurar para usar href en lugar de data-src
        // O agregar data-src a los elementos
      });
    });
  }
  const faqItems = document.querySelectorAll(".faq-item");
  faqItems.forEach(item => {
    const question = item.querySelector(".faq-question");
    question.addEventListener("click", () => {
      faqItems.forEach(i => {
        if (i !== item) {
          i.classList.remove("active");
        }
      });
      item.classList.toggle("active");
    });
  });

  // Program Grid — mobile scroll-snap carousel (dots + prev/next arrows).
  // Each .program-grid instance on the page gets its own independent
  // carousel state, since this is a repeatable ACF block, not a singleton.
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll(".program-grid").forEach(function (section) {
    const track = section.querySelector(".program-grid__track");
    const dotsWrap = section.querySelector(".program-grid__dots");
    const prevBtn = section.querySelector(".program-grid__arrow--prev");
    const nextBtn = section.querySelector(".program-grid__arrow--next");
    const cards = track ? track.querySelectorAll(".program-grid__card") : [];
    if (!track || !dotsWrap || !cards.length) return;
    cards.forEach(function (_, i) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "h-2 rounded-full border-0 p-0 cursor-pointer transition-all duration-300 " + (i === 0 ? "w-7 bg-gold-500" : "w-2 bg-teal-500/25");
      dot.setAttribute("aria-label", "Go to program " + (i + 1));
      dot.addEventListener("click", function () {
        scrollToCard(i);
      });
      dotsWrap.appendChild(dot);
    });
    const dots = dotsWrap.querySelectorAll("button");
    function current() {
      const center = track.scrollLeft + track.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      cards.forEach(function (card, i) {
        const mid = card.offsetLeft + card.offsetWidth / 2;
        const dist = Math.abs(mid - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      });
      return best;
    }
    function scrollToCard(i) {
      i = Math.max(0, Math.min(cards.length - 1, i));
      const card = cards[i];
      track.scrollTo({
        left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2,
        behavior: reduceMotion ? "auto" : "smooth"
      });
    }
    function sync() {
      const i = current();
      dots.forEach(function (dot, di) {
        const isActive = di === i;
        dot.classList.toggle("w-7", isActive);
        dot.classList.toggle("bg-gold-500", isActive);
        dot.classList.toggle("w-2", !isActive);
        dot.classList.toggle("bg-teal-500/25", !isActive);
      });
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= cards.length - 1;
    }
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        scrollToCard(current() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        scrollToCard(current() + 1);
      });
    }
    let ticking = false;
    track.addEventListener("scroll", function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          ticking = false;
          sync();
        });
        ticking = true;
      }
    }, {
      passive: true
    });
    window.addEventListener("resize", sync);
    sync();
  });

  // Hero — background parallax on scroll (skipped entirely under
  // prefers-reduced-motion, matching page-test.php).
  if (!reduceMotion) {
    const heroBgs = document.querySelectorAll(".hero-bg");
    if (heroBgs.length) {
      let heroTicking = false;
      function updateHeroParallax() {
        heroBgs.forEach(function (bg) {
          bg.style.transform = "translate3d(0," + window.scrollY * 0.35 + "px,0) scale(1.05)";
        });
        heroTicking = false;
      }
      window.addEventListener("scroll", function () {
        if (!heroTicking) {
          requestAnimationFrame(updateHeroParallax);
          heroTicking = true;
        }
      }, {
        passive: true
      });
    }
  }

  // Facility Gallery — lightbox. Each .facility-gallery instance owns its
  // own .rlb overlay (rendered server-side right alongside its .rg-grid)
  // rather than one shared lightbox appended to document.body, so multiple
  // galleries on the same page don't collide.
  document.querySelectorAll(".facility-gallery").forEach(function (section) {
    const grid = section.querySelector(".rg-grid");
    const lb = section.querySelector(".rlb");
    if (!grid || !lb) return;
    const items = Array.prototype.slice.call(grid.querySelectorAll(".rg-i"));
    if (!items.length) return;
    const img = lb.querySelector(".rlb-img");
    const cap = lb.querySelector(".rlb-cap");
    const cnt = lb.querySelector(".rlb-count");
    const closeBtn = lb.querySelector(".rlb-close");
    let i = 0;
    let trigger = null;
    function show(n) {
      i = (n + items.length) % items.length;
      const src = items[i].querySelector("img");
      img.src = src.src;
      img.alt = src.alt || "";
      cap.textContent = items[i].dataset.cap || "";
      cnt.textContent = i + 1 + " / " + items.length;
    }
    function open(n) {
      trigger = items[n];
      show(n);
      lb.classList.add("is-open");
      document.body.style.overflow = "hidden";
      setSiblingsInert(lb, true);
      closeBtn.focus();
    }
    function close() {
      lb.classList.remove("is-open");
      document.body.style.overflow = "";
      setSiblingsInert(lb, false);
      if (trigger) trigger.focus();
    }
    items.forEach(function (b, n) {
      b.addEventListener("click", function () {
        open(n);
      });
    });
    closeBtn.addEventListener("click", close);
    lb.querySelector(".rlb-prev").addEventListener("click", function () {
      show(i - 1);
    });
    lb.querySelector(".rlb-next").addEventListener("click", function () {
      show(i + 1);
    });
    lb.addEventListener("click", function (e) {
      if (e.target === lb) close();
    });
    lb.addEventListener("keydown", function (e) {
      if (!lb.classList.contains("is-open")) return;
      if (e.key === "Escape") {
        close();
        return;
      }
      if (e.key === "ArrowLeft") show(i - 1);
      if (e.key === "ArrowRight") show(i + 1);
      if (e.key === "Tab") {
        const focusable = lb.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  });

  // Stories — single-slide fade carousel with autoplay, matching
  // page-test.php's behavior (7s interval, paused on hover, no autoplay
  // under prefers-reduced-motion). Each .stories instance runs independently
  // since this is a repeatable ACF block, not a singleton.
  document.querySelectorAll(".stories").forEach(function (section) {
    const slides = section.querySelectorAll(".stories-slide");
    const stage = section.querySelector(".stories-stage");
    const dotsWrap = section.querySelector(".stories-dots");
    const prevBtn = section.querySelector(".stories-arrow--prev");
    const nextBtn = section.querySelector(".stories-arrow--next");
    if (!slides.length || !dotsWrap || !stage) return;
    const dotActive = dotsWrap.dataset.active || "bg-teal-500";
    const dotInactive = dotsWrap.dataset.inactive || "bg-teal-500/25";
    slides.forEach(function (_, i) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "h-2 rounded-full border-0 p-0 cursor-pointer transition-all duration-300 " + (i === 0 ? "w-7 " + dotActive : "w-2 " + dotInactive);
      dot.setAttribute("aria-label", "Go to story " + (i + 1));
      if (i === 0) dot.setAttribute("aria-current", "true");
      dot.addEventListener("click", function () {
        go(i);
      });
      dotsWrap.appendChild(dot);
    });
    const dots = dotsWrap.querySelectorAll("button");
    let idx = 0;
    let timer = null;

    // Slides are position:absolute inset-0 (needed for the crossfade), which
    // pins each slide's own box to the stage's current height rather than
    // its content — so slide.scrollHeight just reports back whatever height
    // the stage already has (or, once it's grown for a long story, gets
    // stuck reporting that same tall value for a later short story, since
    // content shorter than an explicitly-sized box never shrinks it). Read
    // the actual rendered extent of the slide's own children instead, which
    // stay content-sized regardless of the stretched parent.
    function syncHeight() {
      const active = slides[idx];
      if (!active || !active.firstElementChild) return;
      const first = active.firstElementChild.getBoundingClientRect();
      const last = active.lastElementChild.getBoundingClientRect();
      stage.style.height = last.bottom - first.top + "px";
    }
    function render() {
      slides.forEach(function (slide, i) {
        const isActive = i === idx;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });
      dots.forEach(function (dot, i) {
        const isActive = i === idx;
        dot.classList.toggle("w-7", isActive);
        dot.classList.toggle(dotActive, isActive);
        dot.classList.toggle("w-2", !isActive);
        dot.classList.toggle(dotInactive, !isActive);
        if (isActive) dot.setAttribute("aria-current", "true");else dot.removeAttribute("aria-current");
      });
      syncHeight();
    }
    function go(i) {
      idx = (i + slides.length) % slides.length;
      render();
      restart();
    }
    function restart() {
      if (timer) clearInterval(timer);
      if (!reduceMotion) {
        timer = setInterval(function () {
          go(idx + 1);
        }, 7000);
      }
    }
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        go(idx - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        go(idx + 1);
      });
    }
    section.addEventListener("mouseenter", function () {
      if (timer) clearInterval(timer);
    });
    section.addEventListener("mouseleave", restart);
    // Pause on keyboard focus too, not just mouse hover, so the content
    // doesn't keep rotating out from under a keyboard user reading it.
    section.addEventListener("focusin", function () {
      if (timer) clearInterval(timer);
    });
    section.addEventListener("focusout", function (e) {
      if (!section.contains(e.relatedTarget)) restart();
    });

    // Text reflows at other viewport widths (and web fonts can still be
    // swapping in after first paint), so the height measured at load time
    // isn't final — resync instead of leaving the first-paint height stuck.
    let resizeTimer = null;
    window.addEventListener("resize", function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncHeight, 150);
    });
    window.addEventListener("load", syncHeight);
    syncHeight();
    restart();
  });

  // Page Banner — background parallax (simple scrollY-driven, no scale,
  // matching the internal-page banner's lighter effect vs. the homepage
  // hero). Scoped per instance for the same repeatable-block reason as above.
  if (!reduceMotion) {
    const pbBgs = document.querySelectorAll(".pb-bg");
    if (pbBgs.length) {
      let pbTicking = false;
      function updatePbParallax() {
        pbBgs.forEach(function (bg) {
          bg.style.transform = "translate3d(0," + window.scrollY * 0.28 + "px,0)";
        });
        pbTicking = false;
      }
      window.addEventListener("scroll", function () {
        if (!pbTicking) {
          requestAnimationFrame(updatePbParallax);
          pbTicking = true;
        }
      }, {
        passive: true
      });
      updatePbParallax();
    }
  }

  // Explore Campus — background parallax, offset by each instance's own
  // position in the viewport (not just scrollY) so it still looks right
  // if the block appears anywhere on the page, or more than once.
  if (!reduceMotion) {
    const ecBgs = document.querySelectorAll(".ec-bg");
    if (ecBgs.length) {
      let ecTicking = false;
      function updateEcParallax() {
        ecBgs.forEach(function (bg) {
          const rect = bg.getBoundingClientRect();
          const vh = window.innerHeight;
          const p = Math.max(-1, Math.min(1, (rect.top + rect.height / 2 - vh / 2) / vh));
          bg.style.transform = "translate3d(0," + p * -40 + "px,0) scale(1.08)";
        });
        ecTicking = false;
      }
      window.addEventListener("scroll", function () {
        if (!ecTicking) {
          requestAnimationFrame(updateEcParallax);
          ecTicking = true;
        }
      }, {
        passive: true
      });
      updateEcParallax();
    }
  }

  // Header phone CTA reveal — shown only once none of the in-page phone CTAs
  // (hero, final, footer) are on screen, so the fixed nav pill never sits on
  // top of one of them for the rest of the scroll. Also toggles the mobile
  // sticky call bar (#callbar) if present, though that isn't built yet — the
  // reveal still works for the nav without it.
  const callbar = document.getElementById("callbar");
  const callbarCtas = document.querySelectorAll(".hero-phone, .final-phone, .footer .tel, .pb-call");
  if (callbarCtas.length && "IntersectionObserver" in window) {
    const ctaVisible = new Map();
    callbarCtas.forEach(function (el) {
      ctaVisible.set(el, true);
    });
    const callbarIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        ctaVisible.set(entry.target, entry.isIntersecting);
      });
      const anyVisible = Array.from(ctaVisible.values()).some(function (v) {
        return v;
      });
      const out = !anyVisible;
      if (callbar) {
        callbar.classList.toggle("show", out);
        callbar.setAttribute("aria-hidden", out ? "false" : "true");
      }
      document.body.classList.toggle("navphone-show", out);
    }, {
      threshold: 0,
      rootMargin: "-120px 0px 0px 0px"
    });
    callbarCtas.forEach(function (el) {
      callbarIo.observe(el);
    });
  }
});
const megaMenuPosition = () => {
  // Covers both true mega panels and plain single-column dropdowns — either
  // can overflow the viewport edge depending on where its trigger sits in
  // the (centered) nav bar.
  const panels = document.querySelectorAll(".header-nav > li.menu-item-has-children.active > .mega-menu-container:not(.mega-menu-container--tabs), " + ".header-nav > li.menu-item-has-children.active > .sub-menu");
  panels.forEach(container => {
    container.style.marginLeft = "0px";
    const xPosition = container.parentElement.getBoundingClientRect().left;
    const menuOffset = xPosition + window.scrollX;
    const menuWidth = container.offsetWidth;
    const viewportWidth = window.innerWidth;
    if (menuOffset + menuWidth > viewportWidth) {
      container.style.marginLeft = "-" + (menuOffset + menuWidth - viewportWidth + 20) + "px";
    }
  });
};

// Makes everything OUTSIDE a given element inert (unreachable to both
// keyboard Tab and screen-reader virtual-cursor/browse-mode navigation)
// while it's open, by walking up from it and inerting only its
// side-branches at each ancestor level — never the element's own ancestor
// chain, which needs to stay interactive. Used by the mobile drawer and the
// facility-gallery lightbox, neither of which is a direct child of <body>.
const setSiblingsInert = (el, isInert) => {
  let node = el;
  while (node && node !== document.body) {
    const parent = node.parentElement;
    if (parent) {
      Array.from(parent.children).forEach(sibling => {
        if (sibling === node) return;
        if (isInert) sibling.setAttribute("inert", "");else sibling.removeAttribute("inert");
      });
    }
    node = parent;
  }
};
const setNavItemExpanded = (link, expanded) => {
  link.classList.toggle("active", expanded);
  const trigger = link.querySelector(":scope > a");
  if (trigger) trigger.setAttribute("aria-expanded", expanded ? "true" : "false");
};
const closeAllMainNavLinks = except => {
  document.querySelectorAll(".header-nav > li.menu-item-has-children").forEach(link => {
    if (link !== except) {
      setNavItemExpanded(link, false);
    }
  });
};
document.addEventListener("DOMContentLoaded", function () {
  const mainNavLinks = document.querySelectorAll(".header-nav > li.menu-item-has-children");
  let closeTimer = null;
  mainNavLinks.forEach(link => {
    link.querySelector("a").addEventListener("click", function (e) {
      e.preventDefault();
      const willOpen = !link.classList.contains("active");
      closeAllMainNavLinks(link);
      setNavItemExpanded(link, willOpen);
      megaMenuPosition();
    });

    // Hover-intent open with a short close delay, so moving from the
    // trigger to the panel doesn't flicker-close it.
    link.addEventListener("mouseenter", function () {
      clearTimeout(closeTimer);
      closeAllMainNavLinks(link);
      setNavItemExpanded(link, true);
      megaMenuPosition();
    });
    link.addEventListener("mouseleave", function () {
      closeTimer = setTimeout(() => {
        setNavItemExpanded(link, false);
      }, 130);
    });
    link.addEventListener("focusout", function (e) {
      if (!link.contains(e.relatedTarget)) {
        setNavItemExpanded(link, false);
      }
    });
  });

  // Handle click outside
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".header-nav")) {
      closeAllMainNavLinks(null);
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeAllMainNavLinks(null);
    }
  });

  // Tabs-mega tab strip — implements the WAI-ARIA Tabs pattern: activating a
  // tab (click, Enter/Space, or Left/Right/Home/End arrow keys) shows its
  // panel and moves it into the Tab order (roving tabindex), matching the
  // role="tab"/aria-selected markup rendered in class-custom-navwalker.php.
  document.querySelectorAll(".mega-menu-container__tabs-nav").forEach(tablist => {
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    function activateTab(tab) {
      const panelId = tab.getAttribute("aria-controls");
      document.querySelectorAll(".mega-menu-container__tabs-content-item").forEach(panel => {
        panel.classList.toggle("active", panel.id === panelId);
      });
      tabs.forEach(t => {
        const isActive = t === tab;
        t.closest("li").classList.toggle("active", isActive);
        t.setAttribute("aria-selected", isActive ? "true" : "false");
        t.setAttribute("tabindex", isActive ? "0" : "-1");
      });
    }
    tabs.forEach((tab, i) => {
      tab.addEventListener("click", function (e) {
        e.preventDefault();
        activateTab(tab);
      });
      tab.addEventListener("mouseenter", function () {
        activateTab(tab);
      });
      tab.addEventListener("keydown", function (e) {
        let target = null;
        if (e.key === "ArrowRight") target = tabs[(i + 1) % tabs.length];else if (e.key === "ArrowLeft") target = tabs[(i - 1 + tabs.length) % tabs.length];else if (e.key === "Home") target = tabs[0];else if (e.key === "End") target = tabs[tabs.length - 1];
        if (!target) return;
        e.preventDefault();
        activateTab(target);
        target.focus();
      });
    });
  });

  // Mobile drawer — matches framework-child/page-test.php's own drawer JS:
  // .open toggled directly on #drawer (CSS keyframe handles the fade-in),
  // each .dl-item accordion opens independently, and leaf links close the
  // drawer on tap while .drawer-phone/.drawer-link do not (tel: links and
  // top-level items don't navigate away from the page).
  const mobileNavToggle = document.getElementById("mobile-nav-toggle");
  const drawerClose = document.getElementById("drawerClose");
  const drawer = document.getElementById("drawer");
  const body = document.body;
  function openDrawer() {
    if (drawer) {
      drawer.classList.add("open");
      drawer.setAttribute("aria-hidden", "false");
      setSiblingsInert(drawer, true);
    }
    body.classList.add("mobile-nav-open");
    document.documentElement.classList.add("mobile-nav-open");
    if (mobileNavToggle) {
      mobileNavToggle.setAttribute("aria-expanded", "true");
      mobileNavToggle.setAttribute("aria-label", "Close menu");
    }
    if (drawerClose) drawerClose.focus();
  }
  function closeDrawer() {
    if (drawer) {
      drawer.classList.remove("open");
      drawer.setAttribute("aria-hidden", "true");
      setSiblingsInert(drawer, false);
    }
    body.classList.remove("mobile-nav-open");
    document.documentElement.classList.remove("mobile-nav-open");
    if (mobileNavToggle) {
      mobileNavToggle.setAttribute("aria-expanded", "false");
      mobileNavToggle.setAttribute("aria-label", "Open menu");
      mobileNavToggle.focus();
    }
  }
  if (mobileNavToggle) {
    mobileNavToggle.addEventListener("click", function () {
      if (drawer && drawer.classList.contains("open")) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }
  if (drawerClose) {
    drawerClose.addEventListener("click", closeDrawer);
  }

  // Basic focus trap while the drawer is open.
  if (drawer) {
    drawer.addEventListener("keydown", function (e) {
      if (e.key !== "Tab" || !drawer.classList.contains("open")) {
        return;
      }
      const focusable = drawer.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && drawer.classList.contains("open")) {
      closeDrawer();
    }
  });
  window.addEventListener("resize", function () {
    if (window.innerWidth > 1024 && drawer && drawer.classList.contains("open")) {
      closeDrawer();
    }
  });
  document.querySelectorAll(".dl-trigger").forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      const item = trigger.closest(".dl-item");
      if (!item) return;
      const isOpen = item.classList.toggle("open");
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  });
  if (drawer) {
    drawer.querySelectorAll("a:not(.drawer-phone):not(.drawer-link)").forEach(function (a) {
      a.addEventListener("click", closeDrawer);
    });
  }
});
window.addEventListener("resize", function () {
  megaMenuPosition();
});

// Locations Map — Google Maps JS API init, ported from woodland-recovery's
// wlInitMap() and re-themed. Must be a true global (not inside
// DOMContentLoaded) since the Maps script invokes it directly via its
// ?callback= URL param, and enqueued conditionally in setup-assets.php only
// when the acf/locations-map block is present. Scoped per .locations-map
// instance so more than one map on a page (or none) both work correctly.
function bamInitMap() {
  document.querySelectorAll(".locations-map").forEach(function (section) {
    const mapEl = section.querySelector(".locations-map__map");
    if (!mapEl) return;
    const chips = Array.prototype.slice.call(section.querySelectorAll(".locations-map__chip"));
    if (!chips.length) return;
    const locs = chips.map(function (chip) {
      return {
        lat: parseFloat(chip.dataset.lat) || 0,
        lng: parseFloat(chip.dataset.lng) || 0,
        zoom: parseInt(chip.dataset.zoom, 10) || 14,
        name: chip.dataset.name || ""
      };
    });

    // Muted cream/teal map style, matching the theme's palette instead of
    // Woodland's nature-green one.
    const mapStyles = [{
      elementType: "geometry",
      stylers: [{
        color: "#f6efe2"
      }]
    }, {
      elementType: "labels.text.fill",
      stylers: [{
        color: "#3a4044"
      }]
    }, {
      elementType: "labels.text.stroke",
      stylers: [{
        color: "#faf6ec"
      }]
    }, {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{
        color: "#00263e"
      }]
    }, {
      featureType: "poi",
      elementType: "geometry",
      stylers: [{
        color: "#dbeae9"
      }]
    }, {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{
        color: "#3a4044"
      }]
    }, {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{
        color: "#dfe3de"
      }]
    }, {
      featureType: "road",
      elementType: "geometry",
      stylers: [{
        color: "#ffffff"
      }]
    }, {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{
        color: "#e6dfd3"
      }]
    }, {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{
        color: "#e8ddc8"
      }]
    }, {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{
        color: "#cbb98f"
      }]
    }, {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{
        color: "#dbeae9"
      }]
    }, {
      featureType: "water",
      elementType: "geometry",
      stylers: [{
        color: "#b7d0d3"
      }]
    }, {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{
        color: "#00263e"
      }]
    }];
    const pinIcon = {
      path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" + "m0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z",
      fillColor: "#c2882c",
      fillOpacity: 1,
      strokeColor: "#ffffff",
      strokeWeight: 1.5,
      scale: 1.8,
      anchor: new google.maps.Point(12, 22)
    };
    const map = new google.maps.Map(mapEl, {
      center: {
        lat: locs[0].lat,
        lng: locs[0].lng
      },
      zoom: locs.length > 1 ? 8 : locs[0].zoom,
      styles: mapStyles,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      }
    });
    const markers = locs.map(function (loc, i) {
      const marker = new google.maps.Marker({
        position: {
          lat: loc.lat,
          lng: loc.lng
        },
        map: map,
        title: loc.name,
        icon: pinIcon
      });
      marker.addListener("click", function () {
        activateLocation(i);
      });
      return marker;
    });
    if (locs.length > 1) {
      const bounds = new google.maps.LatLngBounds();
      locs.forEach(function (loc) {
        bounds.extend({
          lat: loc.lat,
          lng: loc.lng
        });
      });
      map.fitBounds(bounds, {
        top: 60,
        right: 60,
        bottom: 60,
        left: 60
      });
    }
    function activateLocation(i) {
      chips.forEach(function (chip, n) {
        const isOn = n === i;
        chip.setAttribute("aria-current", isOn ? "true" : "false");
        chip.classList.toggle("bg-gold-500/[.16]", isOn);
        chip.classList.toggle("border-gold-500", isOn);
        chip.classList.toggle("bg-white/[.05]", !isOn);
        chip.classList.toggle("border-white/[.16]", !isOn);
      });
      map.panTo({
        lat: locs[i].lat,
        lng: locs[i].lng
      });
      map.setZoom(locs[i].zoom);
      markers[i].setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(function () {
        markers[i].setAnimation(null);
      }, 700);
    }
    chips.forEach(function (chip, i) {
      chip.addEventListener("click", function () {
        activateLocation(i);
      });
    });
    activateLocation(0);
  });
}
window.bamInitMap = bamInitMap;